import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { EmptyStateImages, ErrorStatePageError, NoResult } from 'ui/illustrations';
import { Link } from 'ui/links';
import { spacing } from 'ui/theme';
import { useTranslations } from 'modules/creativeLibrary/hooks/useTranslations';
import { useAssetsQueryContext } from '../../../contexts/AssetsQueryContext';
import { useFilterContext } from '../../../contexts/FilterContext';

const KNOWLEDGE_CENTER_URL = 'https://support.iterable.com/';

const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  justify-content: center;
  padding: ${spacing.x5};
  position: relative;
  height: 100%;
`;

export const EmptyStateContent = () => {
  const { assets, folders, isLoading, hasError } = useAssetsQueryContext();
  const { hasFilters } = useFilterContext();
  const { t } = useTranslations();

  const hasContent = assets.length > 0 || folders.length > 0;

  if (isLoading) {
    return null;
  }

  if (hasError) {
    return (
      <EmptyStateWrapper>
        <EmptyState
          Illustration={ErrorStatePageError}
          title={t('emptyState.error.title')}
          subtitle={t('emptyState.error.subtitle')}
        />
      </EmptyStateWrapper>
    );
  }

  if (!hasContent && !hasFilters) {
    return (
      <EmptyStateWrapper>
        <EmptyState
          Illustration={EmptyStateImages}
          title={t('emptyState.noImages.title')}
          subtitle={
            <div>
              {t('emptyState.noImages.subtitle')}
              <Link size="body1" href={KNOWLEDGE_CENTER_URL} target="_blank">
                {t('emptyState.noImages.helpLink')}
              </Link>
              .
            </div>
          }
        />
      </EmptyStateWrapper>
    );
  }

  // No search/filter results
  if (!hasContent && hasFilters) {
    return (
      <EmptyStateWrapper>
        <EmptyState
          Illustration={NoResult}
          title={t('emptyState.noResults.title')}
          subtitle={t('emptyState.noResults.subtitle')}
        />
      </EmptyStateWrapper>
    );
  }

  return null;
};
